import React from 'react';
import { useLocation } from 'react-router-dom';
import routes from '../../../../../routes/constants';
import { isRouteMatching } from '../../../../../utilities/routes';
import FileManagerNav from './FileManagerNav';
import Map2DNav from './Map2DNav';
import Viewer3DNav from './Viewer3DNav';
var Titlebar = function(param) {
    var _param_showShareLink = param.showShareLink, showShareLink = _param_showShareLink === void 0 ? false : _param_showShareLink;
    var location = useLocation();
    var isVisibleToRoute = isRouteMatching(location.pathname);
    return /*#__PURE__*/ React.createElement("div", {
        className: "Titlebar"
    }, isVisibleToRoute(routes.order.root) && /*#__PURE__*/ React.createElement(Map2DNav, {
        className: "Navbar-Item",
        showShareLink: showShareLink
    }), isVisibleToRoute(routes.fileManager.root) && /*#__PURE__*/ React.createElement(FileManagerNav, {
        className: "Navbar-Item",
        showShareLink: showShareLink
    }), isVisibleToRoute(routes.view3D.project()) && /*#__PURE__*/ React.createElement(Viewer3DNav, {
        className: "Navbar-Item",
        showShareLink: showShareLink
    }));
};
export default Titlebar;
